import { ArrowDownLeft, ArrowUpRight, History, Receipt, Smartphone, UserRound } from "lucide-react";
import { site } from "../content/site";
import { Reveal } from "./Reveal";
import { SectionHeader } from "./SectionHeader";

const icons = { ArrowUpRight, ArrowDownLeft, Receipt, Smartphone, History, UserRound };

export const Features = () => (
  <section id="features" className="border-t border-gray-200 bg-gray-50" data-testid="features-section">
    <div className="mx-auto max-w-7xl px-4 py-20 sm:px-6 lg:px-8 lg:py-24">
      <SectionHeader
        eyebrow={site.features.eyebrow}
        heading={site.features.heading}
        subcopy={site.features.subcopy}
        testid="features-heading"
      />
      <div className="mt-14 grid grid-cols-1 gap-x-10 gap-y-12 sm:grid-cols-2 lg:grid-cols-3">
        {site.features.items.map((feature, i) => {
          const Icon = icons[feature.icon];
          return (
            <Reveal key={feature.title} delay={(i % 3) * 0.08} className="border-t border-gray-300 pt-6">
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-brand">
                <Icon className="h-5 w-5 text-white" aria-hidden="true" />
              </span>
              <h3 className="mt-4 font-heading text-lg font-bold text-gray-900">{feature.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-gray-600">{feature.text}</p>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
